import type { FiatPrice } from "@hopper-b2b/types";

export enum WalletPaymentEventTypes {
  SET_WALLET_CREDIT_PAY_AMOUNT = "SET_WALLET_CREDIT_PAY_AMOUNT",
  SET_WALLET_CREDIT_BALANCE = "SET_WALLET_CREDIT_BALANCE",
}

export interface SetWalletCreditAmountEvent {
  type: WalletPaymentEventTypes.SET_WALLET_CREDIT_PAY_AMOUNT;
  amount: FiatPrice;
}

export interface SetWalletCreditBalanceEvent {
  type: WalletPaymentEventTypes.SET_WALLET_CREDIT_BALANCE;
  amount: FiatPrice;
}

export type WalletPaymentEvent =
  | SetWalletCreditAmountEvent
  | SetWalletCreditBalanceEvent;
